import { ShapePinComponent, ShapeType, Size, Vector } from '../../models';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

export type ShapePinComponentProps = {
  position?: Vector;
  rotation?: number;
  size?: Size;
  order?: string;
  shapeType?: ShapeType;
  settings?: Partial<ShapePinComponent['settings']>;
  id?: string;
};

export function newShapePinComponent({
  position = initialPinComponentPosition,
  size = newSize(128, 128),
  rotation = 0,
  order = defaultOrder,
  shapeType = 'RECTANGLE',
  settings,
  id = randomId(),
}: ShapePinComponentProps): ShapePinComponent {
  const lockedAspectRatio = shapeType === 'ICON' ? true : undefined;
  return {
    type: 'SHAPE',
    id,
    settings: {
      ...settings,
      shapeType,
    },
    layout: newBox(position, size, rotation, lockedAspectRatio),
    order,
  };
}
